import { Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { NavController } from '@ionic/angular';
import { UserAddressService } from 'src/app/services/user-address/user-address.service';
import { MapsAPILoader, MouseEvent } from '@agm/core';
import { ActivatedRoute, Params } from '@angular/router';
import { AreaService } from 'src/app/services/Area/area.service';
import { google } from 'google-maps';
@Component({
  selector: 'app-select-location',
  templateUrl: './select-location.page.html',
  styleUrls: ['./select-location.page.scss'],
})
export class SelectLocationPage implements OnInit {
	latitude: number;
	longitude: number;
	zoom: number;
	address: string;
	private geoCoder;
	areaObj:any;
	@ViewChild('search')
	public searchElementRef: ElementRef;
	autocompleteItems:any = [];
	value:any;
	textareaValue:any = "Home";
	userdata:any;
	editflag:boolean = false;
	useraddress:any;
	showMapsFlag:boolean = false;
	newuserAddress:any;
  constructor(
		private navCtrl:NavController,
		private mapsAPILoader: MapsAPILoader,
		private userAddressService:UserAddressService,
		private activatedroute:ActivatedRoute,
		private ngZone: NgZone,
		private areaService:AreaService

	) { 
		this.userdata = JSON.parse(localStorage.getItem('userProfile'));
	}


	ionViewDidEnter(){
		this.areaService.showHome=false  

		this.activatedroute.queryParams.subscribe((x:Params)=>{
			console.log(x);
			if(x && x.value){
				this.useraddress = JSON.parse(x.value);
				this.textareaValue = this.useraddress.userWrittenAddress;
				console.log(this.useraddress);
				this.editflag = true;
				setTimeout(() => {
					this.googlemaps();
				}, 100);
			}else{
				this.editflag = false;
				setTimeout(() => {
					this.googlemaps();
				}, 100);
			}
		})
	}

	goback(){
		this.navCtrl.navigateBack('/address_multiple');
	  }
	
	  ngOnInit() {
	  }
  
	  googlemaps(){
		this.setCurrentLocation();

		this.mapsAPILoader.load().then(() => {
		  this.geoCoder = new google.maps.Geocoder;
		  let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {});
		  
		  autocomplete.addListener("place_changed", () => {
			this.ngZone.run(() => {
			  //get the place result
			  let place = autocomplete.getPlace();
			  
			  //verify result
			  if (place.geometry === undefined || place.geometry === null) {
				return;
			  }
	 
			  this.latitude = place.geometry.location.lat();
			  this.longitude = place.geometry.location.lng();
			  this.zoom = 16;
			  this.getAddress(this.latitude, this.longitude);
			});
		  });
		});
	  }
	
	
	
	
	  private setCurrentLocation() {
		
		if ('geolocation' in navigator) {
		  navigator.geolocation.getCurrentPosition((position) => {
			if(this.useraddress){
			  console.log(this.useraddress.locationObj.lat,this.useraddress.locationObj.long);
			  this.latitude = parseFloat(this.useraddress.locationObj.lat);
			  this.longitude = parseFloat(this.useraddress.locationObj.long);
			  this.zoom = 16;
			  this.showMapsFlag = true;
				this.newuserAddress = this.useraddress.fullAddress

			//   this.getAddress(this.latitude, this.longitude);
			}else{
			this.latitude = position.coords.latitude;
			this.longitude = position.coords.longitude;
			console.log(this.latitude,this.longitude);
			this.zoom = 16;
			this.showMapsFlag = true;
			this.getAddress(this.latitude, this.longitude);
		  }
		  });
		}
	  }
	
	
	  markerDragEnd($event: MouseEvent) {
		console.log($event);
		this.latitude = $event.coords.lat;
		this.longitude = $event.coords.lng;
		this.getAddress(this.latitude, this.longitude);
	  }
	
	  getAddress(latitude, longitude) {
		this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
		  this.areaObj = results[0];
		  if (status === 'OK') {
			if (results[0]) {
			  this.zoom = 16;
			  console.log(results);
			  this.address = results[0].formatted_address;
			  this.newuserAddress = results[0].formatted_address;
			} else {
			  window.alert('No results found');
			}
		  } else {
			window.alert('Geocoder failed due to: ' + status);
		  }
	
		});
	  }
	
	  saveLocation(){
		console.log(this.address,this.latitude,this.longitude); 
		let add = this.address.split(',');
		let state = add[add.length -2].split(' ');
		console.log(add);
		console.log(state);
		let locality ='';
		for(let i = 2;i <add.length-3;i++){
		  locality = locality + add[i];
		}
		let details = {
		  "flatNo": add[0],
		  "streetName": add[1],
		  "locality": locality,
		  "city": add[add.length-3],
		  "state": state[1],
		  "country": add[add.length - 1],
		  "pinCode": state[2],
		  "fullAddress":this.newuserAddress,
		  "userWrittenAddress":this.textareaValue,
		  "userId": this.userdata.id,
		  "locationObj": {"lat":this.latitude,"long":this.longitude}
		}
		console.log(details);
		if(this.editflag){
		  this.userAddressService.editUserAddress(details,this.useraddress.id).then((res)=>{
			console.log(res);
			this.goback();
		  })
		}else{
		  this.userAddressService.addUserAddress(details).then((res)=>{
			console.log(res);
			this.goback();
		  })
		}
		
		
	  }
  
}
